import lang from "@/views/modules/ApplicationBudgets/language/en";

let metaList = [
    {
        label: lang.LBL_BT_NAME,
        link: true,
        columnName: 'name',
    },
    {
        label: lang.LBL_CR_MULTIPIER,
        link: false,
        columnName: 'currency_multiplier',
    },
    {
        label: lang.LBL_PROJECT_NAME,
        link: false,
        columnName: 'application_title',
    },
    {
        label: lang.LBL_OPPORT_NAME,
        link: false,
        columnName: 'opportunity_title',
    }
];
const link_list = {
    routePath: 'applicationbudgets',
    title: 'Recent Active Application Budgets',
    search: {app_budget_status:{
        key:'app_budget_status',
        value:'Pending'
    }},
    sort: {
        order: 'desc',
        column: 'date_entered',
    },
    perPage: 10,
}
export default { metaList, link_list }